var map = {
	"../pages/cdm/class/home.class.module": [
		974,
		35
	],
	"../pages/cdm/search/search.view.module": [
		975,
		34
	],
	"../pages/cdm/topic/coverage.create.module": [
		976,
		33
	],
	"../pages/cdm/topic/topic.create.module": [
		977,
		23
	],
	"../pages/cdm/tree/tree.view.module": [
		978,
		22
	],
	"../pages/chat/chat.module": [
		980,
		13
	],
	"../pages/coverage/admin/coverage.admin.module": [
		979,
		11
	],
	"../pages/coverage/feed/coverage.feed.module": [
		981,
		10
	],
	"../pages/coverage/home/coverage.home.module": [
		1006,
		14
	],
	"../pages/coverage/list/coverage.list.module": [
		982,
		12
	],
	"../pages/coverage/news/coverage.news.module": [
		983,
		2
	],
	"../pages/coverage/post/post.detail.module": [
		984,
		9
	],
	"../pages/coverage/provider/coverage.provider.module": [
		985,
		8
	],
	"../pages/coverage/select/modal-nav/modal-nav.module": [
		986,
		32
	],
	"../pages/coverage/select/modal-with-navigation.module": [
		987,
		31
	],
	"../pages/coverage/select/move-document/move-document.module": [
		988,
		24
	],
	"../pages/coverage/story/coverage.story.module": [
		989,
		26
	],
	"../pages/coverage/storyslide/coverage.storyslide.module": [
		990,
		25
	],
	"../pages/coverage/tabs/coverage.tabs.module": [
		991,
		7
	],
	"../pages/coverage/topic/coverage.topic.module": [
		992,
		1
	],
	"../pages/coverage/view/coverage.view.module": [
		993,
		0
	],
	"../pages/crypto/list/list.module": [
		994,
		6
	],
	"../pages/crypto/my-cart/my-cart.module": [
		996,
		5
	],
	"../pages/form/basket/basket.share.module": [
		995,
		20
	],
	"../pages/form/newsletter/form.newsletter.module": [
		997,
		19
	],
	"../pages/product/filter/product.filter.module": [
		1007,
		18
	],
	"../pages/product/like/product.like.module": [
		998,
		17
	],
	"../pages/product/list/product.list.module": [
		1008,
		16
	],
	"../pages/product/view/product.view.module": [
		1009,
		15
	],
	"../pages/timeline/timeline.module": [
		999,
		4
	],
	"../pages/victoire/answer/answer.module": [
		1000,
		30
	],
	"../pages/victoire/ask/ask.module": [
		1001,
		29
	],
	"../pages/victoire/home/home.module": [
		1002,
		21
	],
	"../pages/victoire/modal/modal.module": [
		1003,
		28
	],
	"../pages/victoire/notification/notification.module": [
		1004,
		27
	],
	"../pages/victoire/tabs/victoire.tabs.module": [
		1005,
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 316;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 316
// module chunks = 36